import { Modal, Button } from 'react-bootstrap'
import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { MDBDataTableV5 } from 'mdbreact'
import CreateOrEditTeam from './CreateOrEditTeam'
import { Link } from 'react-router-dom'
import GetCricketTeamsList from '../../Services/Queries/GetCricketTeamsList'
import DeleteCricketTeam from '../../Services/Mutations/DeleteCricketTeam'
import AwsConfig from '../../Config/AwsConfig'

class UsersList extends React.Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }

  constructor(props) {
    super(props)
    this.state = {
      data: {
        columns: [
          {
            label: 'Id',
            field: 'id',
            width: 150,
          },
          {
            label: 'Team Name',
            field: 'teamName',
            width: 150,
          },
          {
            label: 'Team Short Name',
            field: 'teamShortName',
            width: 270,
          },
          {
            label: 'Team Image',
            field: 'teamImage',
            width: 200,
          },
          {
            label: 'Team Logo',
            field: 'teamLogo',
            width: 80,
          },
          {
            label: 'Actions',
            field: 'action',
            width: 80,
          },
        ],
        rows: [],
      },
      itemToEdit: {},
      itemToDelete: {},
      createUserModalVisible: false,
      deleteModalVisible: false,
      editMode: false,
    }
  }

  componentDidMount = async () => {
    const response = await GetCricketTeamsList()
    console.log(response, 'response=============')
    // if (response.status === 200) {
    let teamsList = []
    const ListItems = response.items && response.items.length > 0 ? response.items : []
    const cdnurl = AwsConfig.cdn_url
    ListItems.map((item, index) => {
      const logo = item.teamLogo ? cdnurl + item.teamLogo : ''
      const image = item.teamImage ? cdnurl + item.teamImage : ''
      item.action = (
        <div className='d-flex'>
          <div className='btn btn-danger btn-sm mr-3 ' onClick={() => this.openDeleteModal(item)}>
            <i className='nav-icon fas fa-trash' />
          </div>
          <div className='btn btn-info btn-sm mr-3 ' onClick={() => this.openEditModal(item)}>
            <i className='nav-icon fas fa-edit' />
          </div>
        </div>
      )
      item.teamImage = <img src={image} alt='' border='3' width='100' height='100' />
      item.teamLogo = (
        <img src={logo} alt='' border='3' width='100' height='100' style={{ borderRadius: 50 }} />
      )
      item.id = parseInt(ListItems.length) - index
      teamsList.push(item)
    })
    // this.setState({teaserList: teamsList})
    const newObj = { ...this.state.data, rows: teamsList }
    // this.setState({car: newObj })
    this.setState({ data: newObj })
    // } else {
    //   this.setState({ displayLoader: false })

    // }
  }
  openEditModal = (item) => {
    this.setState({ createUserModalVisible: true, itemToEdit: item, editMode: true })
  }
  openDeleteModal = (item) => {
    this.setState({ deleteModalVisible: true, itemToDelete: item })
  }
  closeDeleteModal = () => {
    this.setState({ deleteModalVisible: false })
  }
  openUserModal = () => {
    this.setState({ createUserModalVisible: true })
  }
  closeUserModal = () => {
    this.setState({ createUserModalVisible: false, itemToEdit: {}, editMode: false })
  }
  deleteTeam = async () => {
    const { itemToDelete } = this.state
    let teamsList = this.state.data.rows
    const deleteTeamInput = {
      PK: itemToDelete.PK,
      SK: itemToDelete.SK,
    }
    console.log(deleteTeamInput, 'deleteTeamInput')
    const response = await DeleteCricketTeam(deleteTeamInput)
    console.log(response, 'response')
    if (response.statusCode === 'A339') {
      const filteredTeasersList = teamsList.filter((team) => team.SK !== itemToDelete.SK)
      toast.success('Team Deleted Successfully', this.toastStyle)
      const newTableData = { ...this.state.data, rows: filteredTeasersList }
      this.setState({ data: newTableData, deleteModalVisible: false })
    } else {
      toast.error('Failed to delete Team..Retry !!', this.toastStyle)
      this.setState({ deleteModalVisible: false })
    }
  }

  renderDeleteModal = () => {
    const { deleteModalVisible } = this.state
    return (
      <Modal show={deleteModalVisible} onHide={() => this.closeDeleteModal()}>
        <Modal.Body>
          <div>Are You Sure You Want To Delete This Team ?</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='success' onClick={() => this.deleteTeam()}>
            Continue
          </Button>

          <Button variant='danger' onClick={() => this.closeDeleteModal()}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  render() {
    const { createUserModalVisible } = this.state
    return (
      <div className=''>
        {this.renderDeleteModal()}
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <section>
          <div className='d-flex justify-content-end'>
            <Link to={`/createTeam`}>
              <button className='btn btn-success mr-2 mb-2'>Add New</button>
            </Link>
          </div>
          <Modal show={createUserModalVisible} onHide={() => this.closeUserModal()}>
            <CreateOrEditTeam editMode={true} itemData={this.state.itemToEdit} />
          </Modal>
          {this.state.data.rows.length > 0 ? (
            <div className='card p-3 '>
              <MDBDataTableV5
                searchTop
                searchBottom={false}
                hover
                entriesOptions={[5, 10, 15, 20, 25, 50, 75, 100]}
                entries={5}
                pagesAmount={4}
                data={this.state.data}
                // checkbox

                // getValueCheckBox={(e) => {
                //   showLogs2(e);
                // }}
                // getValueAllCheckBoxes={(e) => {
                //   showLogs2(e);
                // }}
                // multipleCheckboxes
              />
            </div>
          ) : null}
        </section>
      </div>
    )
  }
}

export default UsersList
